import React, {useState,useEffect} from 'react'
import { useParams } from 'react-router-dom';
import { useApi } from '../context/ApiContext';

import Footer from '../components/Footer'
import Navbar from '../components/Navbar';
import InnerLeadBanner from '../components/InnerLeadBanner';

const OpportunityDetails = () => {
    const API_BASE_URL = useApi();

    window.scrollTo(0, 0)
    // This code is used to shorten the location returned since long locations distort UI
    const getShortLocation = (location) => {
            if (!location) return '';

            if (location.length <= 20) return location;

            const breakpoint = location.slice(20).search(/[ ,\.]/); // find first space, comma or period after 20
            if (breakpoint === -1) return location.slice(0, 20) + '...'; // no match, hard cut

            const cutIndex = 20 + breakpoint;
            return location.slice(0, cutIndex) + '...';
            };


    const {id, title} = useParams()

    let [opportunity, setopportunity] = useState([])
    useEffect(()=>{
              getopportunity()
            }, [])


    let getopportunity = async()=>{
        // let fetchUrl = `http://localhost:8000/opportunity-details/${id}`
        let fetchUrl = `${API_BASE_URL}/opportunity-details/${id}`
      let response = await fetch(fetchUrl, {
        method:'GET',
        headers:{
          'Content-Type':'application/json',
        //   'Authorization': 'Bearer ' + String(authTokens.access)
        }
      })
      let data = await response.json()
      if(response.status === 200){
        document.title = `${data[0]?.title || 'Opportunity Details'} | JobFlow`; // <-- Set document title here
        setopportunity(data[0])

        // console.log(data[0])
      }else{
        alert('There is something wrong')
      }
      // setopportunities(data)
    }


  return (

    <>
    <Navbar/>

    <main>
        <InnerLeadBanner title={opportunity?.title || 'Opportunity Details'} />


        {/* <!-- job post company Start --> */}
        <div class="job-post-company pt-120 pb-120">
            <div class="container">
                <div class="row justify-content-between">
                    {/* <!-- Left Content --> */}
                    <div class="col-xl-7 col-lg-8">
                        {/* <!-- job single --> */}
                        <div class="single-job-items mb-50">
                            <div class="job-items">
                                <div class="company-img company-img-details">
                                    <a href="#"><img style={{maxWidth:'100px', maxHeight:'200px'}} src={opportunity.icon} alt="" /></a>
                                </div>
                                <div class="job-tittle">
                                    <a href="#">
                                        <h4>{opportunity.title}</h4>
                                    </a>
                                    <ul>
                                        <li>{opportunity.firm}</li>
                                        <li><i class="fas fa-map-marker-alt"></i>{getShortLocation(opportunity.location)}</li>
                                        <li>{opportunity.remuneration}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                          {/* <!-- job single End --> */}
                       
                        <div class="job-post-details">
                            <div class="post-details1 mb-50">
                                {/* <!-- Small Section Tittle --> */}
                                <div class="small-section-tittle">
                                    {/* <h4>Job Description</h4> */}
                                </div>


                                <div dangerouslySetInnerHTML={{ __html: opportunity.opportunity_details }} />

                                {/* <p>It is a long established fact that a reader will beff distracted by vbthe creadable content of a page when looking at its layout. The pointf of using Lorem Ipsum is that it has ahf mcore or-lgess normal distribution of letters, as opposed to using, Content here content here making it look like readable.</p> */}
                            </div>
                            
                        </div>

                    </div>
                    {/* <!-- Right Content --> */}
                    <div class="col-xl-4 col-lg-4">
                        <div class="post-details3  mb-50">
                            {/* <!-- Small Section Tittle --> */}
                           <div class="small-section-tittle">
                               <h4>Job Overview</h4>
                           </div>
                          <ul>
                              <li>Posted date : <span>{opportunity.formatted_date_time}</span></li>
                              <li>Location : <span>{getShortLocation(opportunity.location)}</span></li>
                              {/* <li>Vacancy : <span>02</span></li> */}
                              <li>Job nature : <span>{opportunity.modality}</span></li>
                              <li>Remuneration :  <span>{opportunity.remuneration}</span></li>
                              <li>Deadline : <span>{opportunity.formatted_deadline}</span></li>
                              {/* <li><button  onClick={() => {
                                    if (navigator.share) {
                                    navigator.share({
                                        title: opportunity.title,
                                        text: opportunity.short_description,
                                        url: `https://backend.com/o/${opportunity.slug}`
                                    });
                                    }
                                }}
                                >
                                Share
                                </button>
                                </li> */}
                               <li>
  <li style={{backgroundColor: '#007bff'}}>
  <button style={{width: '100%'}}
    onClick={() => {
      if (navigator.share) {
        navigator
          .share({
            title: opportunity.title,
            text: opportunity.short_description,
            url: `https://backend.jobflowonline.com/o/${opportunity.id}/${opportunity.title}`,
          })
          .catch((err) => console.log("Share cancelled:", err));
      } else {
        alert("Sharing is not supported on this browser.");
      }
    }}
    className="btn btn-primary d-flex align-items-center gap-2"
  >
    Share 
    <img
      src={require('../assets/img/share.png')}
      alt="Share"
      width="18"
      height="18"
      style={{ filter: "invert(1)" }} // makes it white on blue button
    />
  </button>
</li>

</li>

                          </ul>

                        

                                                <div className="apply-btn2">
                        {opportunity.applications_status === "Live" ? (
                            (() => {
                            const modeMap = {
                                jobflow: {
                                href: `/apply/${opportunity.id}/${opportunity.title}`,
                                label: "Apply Now",
                                },
                                external: {
                                href: opportunity.application_mode_link,
                                label: "Apply Now",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                },
                                
                                whatsapp: {
                                href: `https://wa.me/${opportunity.application_mode_link}`,
                                label: "Apply via WhatsApp",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                },
                                email: {
                                href: `mailto:${opportunity.application_mode_link}`,
                                label: "Apply via Email",
                                },
                                phone_call: {
                                href: `tel:${opportunity.application_mode_link}`,
                                label: "Call Now",
                                },
                            };

                            const mode = modeMap[opportunity.application_mode];

                            return mode ? (
                                <a
                                href={mode.href}
                                className="btn"
                                target={mode.target}
                                rel={mode.rel}
                                >
                                {mode.label}
                                </a>
                            ) : (
                                <span className="btn disabled">Mode not supported</span>
                            );
                            })()
                        ) : (
                            <span className="btn disabled">Deadline passed</span>
                        )}
                        </div>


                       </div>
                        <div class="post-details4  mb-50">
                            {/* <!-- Small Section Tittle --> */}
                           <div class="small-section-tittle">
                               <h4>Company Information</h4>
                           </div>
                              <span>{opportunity.firm}</span>
                              <p>
                            {opportunity.company_information}
                                </p>
                            <ul>
                                {/* <li>Name: <span>Colorlib </span></li> */}
                                <li>Company Phone : <span>{opportunity.company_phone}</span></li>
                                <li>Company Email: <span>{opportunity.company_email}</span></li>
                            </ul>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- job post company End --> */}

    </main>

<Footer />        
    
{/* </html> */}
    
    </>
   
  )
}

export default OpportunityDetails






